import ApiService from "@/common/api.service"

export const TrainingCenterService = {
    create(params) {
        return ApiService.post("TrainingCenters/add", params);
    },
    createFormData(params) {
        return ApiService.postFormData("TrainingCenters/add", params);
    },
    update(slug, params) {
        return ApiService.update("/TrainingCenters", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("/trainingCenter/delete", slug, params)
    },
    async getTrainingCenters() {
        const res = await ApiService.get("/trainingCenters");
        return res.data.rows;
    },
    async getTrainingCentersWP(page, itemsPerPage, name) {
        const res = await ApiService.get(
            `/trainingCenters?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
        return res.data;
    },
    async getAllTrainingCenters() {
        const res = await ApiService.get("/trainingCenters/lookup/list");
        return res.data;
    },
    async getTrainingCentersDrps(params) {
        const res = await ApiService.get(`/trainingCenters/drp${params}`);
        return res.data;
    },
    async getTrainingCentersDrp() {
        const res = await ApiService.get("/trainingCenters/drp");
        return res.data;
    },
    async getTrainingCentersByLocation(locationId) {
        const res = await ApiService.get(`/trainingCenters/lookup/list/${locationId}`);
        return res.data.data;
    },
    async getTrainingCenter(id) {
        const res = await ApiService.get(`/trainingCenters/${id}`);
        return res.data;
    },
    async getRenewals(id) {
        const res = await ApiService.get(`/renewals?cpdId=${id}`);
        return res.data;
    },
    async addRenewal(params) {
        return ApiService.post("renewals/add", params);
    },
    async getTransfers(id) {
        const res = await ApiService.get(`/transfers?cpdId=${id}`);
        return res.data;
    },
    async addTransfer(params) {
        return ApiService.post("transfers/add", params);
    },

}